import template from './holidays_component.html';
import tr from '../../lib/default-translator.js';

class AdminHolidaysComponentViewModel
{
	constructor(bindings)
	{
		this.bindings = bindings;
		let today = new Date();
		let oneyear = new Date().setFullYear(new Date().getFullYear() + 1);
		this.holiday_types = ko.observableArray();
		this.holiday_type_selected = ko.observable();
		this.disable_add_holiday = ko.observable(false);
		this.holidays = ko.observableArray([]);
		this.from_date = ko.observable(new Date(today).toJSON().slice(0, 10));
		this.to_date = ko.observable(new Date(oneyear).toJSON().slice(0, 10));

		this.from_date.subscribe((value) => {
			this.updateData({holiday_types: false});
		});

		this.to_date.subscribe((value) => {
			this.updateData({holiday_types: false});
		});

		this.holiday_type_selected.subscribe((value) => {
			//localStorage.setItem('holiday_type_selected', value);
			this.updateData({holiday_types: false, holidays: true});
			this.disable_add_holiday(false);
		});

		this.delete_holiday = this.delete_holiday.bind(this);
		this.save_holiday = this.save_holiday.bind(this);
		this.add_holiday = this.add_holiday.bind(this);

		this.init();
	}

	back_to_top ()
	{
		document.body.scrollTop = 0; // For Safari
		document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
	}

	async updateData({holiday_types = true, holidays = true} = {})
	{
		if (holidays)
		{
			if (this.holiday_type_selected() != null)
			{
				let res = await Grape.fetches.getJSON('/holiday/list_holidays', {
					holiday_type: this.holiday_type_selected(),
					from_date: this.from_date(),
					to_date: this.to_date()
				});
				this.holidays(res.holidays || []);
			}
		}

		if (holiday_types)
		{
			let res = await Grape.fetches.getJSON('/api/record', {
				table: 'holiday_types',
				schema: 'public'
			});
			this.holiday_types(res.records);
			this.holiday_type_selected(localStorage.getItem('holiday_type_selected') || 'Please select holiday type');
		}
	} async updateData({ holiday_types = true, holidays = true } = {})
	{
		if (holidays)
		{
			if (this.holiday_type_selected() != null)
			{
				let res = await Grape.fetches.getJSON('/holiday/list_holidays', {
					holiday_type: this.holiday_type_selected(),
					from_date: this.from_date(),
					to_date: this.to_date()
				});

				// Remove duplicates based on date and description
				let unique_holidays = [];
				let seen = new Set();
				(res.holidays || []).forEach(holiday => {
					let key = `${holiday.holiday_date}-${holiday.description}-${holiday.holiday_type}`;
					if (!seen.has(key))
					{
						seen.add(key);
						unique_holidays.push(holiday);
					}
				});
				this.holidays(unique_holidays);
			}
		}

		if (holiday_types)
		{
			let res = await Grape.fetches.getJSON('/api/record', {
				table: 'holiday_types',
				schema: 'public'
			});
			this.holiday_types(res.records);
			// Fix localStorage retrieval
			let saved_holiday_type = localStorage.getItem('holiday_type_selected');
			if (saved_holiday_type && saved_holiday_type !== 'Please select holiday type') 
				this.holiday_type_selected(saved_holiday_type);
			else 
				this.holiday_type_selected('Please select holiday type');
		}
	}

	init()
	{
		this.updateData();
	}

	async callDeletePost(data)
	{
		let res = await Grape.fetches.postJSON('/admin/delete_holiday', data);
		
		if (res.status == 'OK')
		{
			await Grape.alerts.alert({type: 'success', message: tr('Successfully deleted holiday.'), title: tr('Success')});
			this.updateData({holiday_types: false});
			this.disable_add_holiday(false);
		}
		else if (res.status == 'ERROR')
			Grape.alerts.apiError(res);
		else
			Grape.alerts.alert({ type: 'error', message: tr('Something went wrong...'), title: tr('Error') });
	};

	async call_save_holiday_post(data)
	{
		let res = await Grape.fetches.postJSON('/admin/save_holiday', data);
		
		if (res.status == 'OK')
		{
			await Grape.alerts.alert({type: 'success', message: tr('Successfully saved holiday.'), title: tr('Success')});
			this.updateData({holiday_types: false});
			this.disable_add_holiday(false);
		}
		else if (res.status == 'ERROR')
			Grape.alerts.apiError(res);
		else
			Grape.alerts.alert({ type: 'error', message: tr('Something went wrong...'), title: tr('Error') });
	};

	async delete_holiday(v, e)
	{
		let data = ko.toJS(v);
		data.command = 'delete';
		// first check if this holiday is safe to modify
		let res = await Grape.fetches.postJSON('/admin/is_holiday_safe_to_modify', data);
		if (res.status == 'OK')
		{
			if (res.is_safe == false)
			{
				let response = await Grape.alerts.confirm({type: 'warning', title: tr('Deleting Holiday Date'),
				message: tr('There are still some leave entries that overlaps with the holiday date that you are deleting. Proceeding will cause these leave entries to be reprocessed.') + ' ' + tr('Number of leave entries: ') + res.old_count + ', ' + tr('Date: ') + res.old_date,
				accept_text: tr('Proceed'), cancel_text: tr('Cancel')});
				
				if (response)
					this.callDeletePost(data);
			}

			if (res.is_safe == true)
				this.callDeletePost(data);
		}
		else if (res.status == 'ERROR')
			Grape.alerts.apiError(res);
		else
			Grape.alerts.alert({ type: 'error', message: tr('Something went wrong...'), title: tr('Error') });
	};

	async save_holiday(data) {
		let value = ko.toJS(data);
		value.command = 'modify';
		// Check that there is a description
		if (value.description == null || value.description == '')
		{
			await Grape.alerts.alert({
				type: 'error',
				title: tr('Invalid input'),
				message: tr('Please provide a name.')
			});
			return;
		}
		// Check that there is a date
		if (value.holiday_date == null || value.holiday_date == '')
		{
			await Grape.alerts.alert({
				type: 'error',
				title: tr('Invalid input'),
				message: tr('Please provide a date.')
			});
			return;
		}
		// Check for duplicates locally first
		if (await this.check_for_duplicates(value))
		{
			await Grape.alerts.alert({
				type: 'error',
				title: tr('Duplicate Holiday'),
				message: tr('A holiday with this date already exists for this holiday type.')
			});
			return;
		}
		// Continue with existing server-side validation
		let res = await Grape.fetches.postJSON('/admin/is_holiday_safe_to_modify', value);
		if (res.status == 'OK')
		{
			if (res.is_safe == false)
			{
				let my_message = '';

				if (res.old_count != null)
					my_message += 'There are ' + res.old_count + ' leave entries that overlaps with the previous date(' + res.old_date + ') ';
				if (res.new_count != null)
					my_message += 'There are ' + res.new_count + ' leave entries that overlaps with the new date(' + res.new_date + ') ';

				my_message += tr('Unfortunately the holiday can not be added because of the overlapping leave');
				Grape.alerts.alert({ type: 'error', message: my_message, title: tr('Error') });
			}
			else 
				this.call_save_holiday_post(value);
		}
		else if (res.status == 'ERROR')
			Grape.alerts.apiError(res);
		else
			Grape.alerts.alert({ type: 'error', message: tr('Something went wrong...'), title: tr('Error') });
	}

	async add_holiday_type()
	{
		await Grape.dialog.open('AdminAddNewHolidayType', {});
		this.updateData();
	}

	async import_holiday()
	{
		await Grape.dialog.open('AdminImportHoliday', { holiday_type: this.holiday_type_selected()});
		this.updateData({holidays: true, holiday_types: false});
	}

	async add_holiday()
	{
		// Check if there's already a new holiday being added (with null id)
		let existing_new_holiday = this.holidays().find(holiday => holiday.id === null);
		if (existing_new_holiday) {
			await Grape.alerts.alert({
				type: 'warning',
				title: tr('Warning'),
				message: tr('Please save or cancel the current holiday before adding a new one.')
			});
			return;
		}

		localStorage.setItem('holiday_type_selected', this.holiday_type_selected());
		let new_holiday = {
			id: null,
			description: '',
			holiday_date: null,
			holiday_type: this.holiday_type_selected()
		};

		if (this.holidays() != null) {
			this.holidays.unshift(new_holiday);
		} else {
			this.holidays([new_holiday]); // Fix: should be array, not object
		}

		this.disable_add_holiday(true);
	}

	//Check for duplicates 
	async check_for_duplicates(holiday_data) {
		let existing_holidays = this.holidays();
		let duplicates = existing_holidays.filter(holiday => 
			holiday.id !== holiday_data.id && // Don't compare with itself
			holiday.holiday_date === holiday_data.holiday_date &&
			holiday.holiday_type === holiday_data.holiday_type
		);
		
		return duplicates.length > 0;
	}

	// Add a cancel method to cancel a holiday before saving 
	cancel_add_holiday()
	{
		// Remove any holidays with null id (unsaved)
		this.holidays.remove(holiday => holiday.id === null);
		this.disable_add_holiday(false);
	}
}

export default {
	name: 'holidays_component',
	viewModel: AdminHolidaysComponentViewModel,
	module_type: 'ko',
	template: template,
	template_filename: 'translation/components/holidays_component'
};
